import { IconProps } from '../../utils/icon';
import { Svg } from '../../utils/IconBase';

const IconCheckLine = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="m9.55 15.15 6.475-8.475c.2-.2.433-.3.7-.3.267 0 .5.1.7.3.2.2.3.438.3.713 0 .274-.1.512-.3.712l-7.175 9.2c-.2.2-.433.3-.7.3a.96.96 0 0 1-.7-.3L5.55 13a.93.93 0 0 1-.287-.713 1.02 1.02 0 0 1 .312-.712c.2-.2.438-.3.713-.3.275 0 .512.1.712.3l2.55 3.575Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconCheckLine;
